import React from 'react';
import PropTypes from 'prop-types';
import { componentWillAppendToBody } from 'react-append-to-body';

import styles from './styles.less';

function Tooltip(_ref) {
  var position = _ref.position,
      text = _ref.text,
      aboveItem = _ref.aboveItem;

  return React.createElement(
    'div',
    { className: styles.tooltipBase, style: Object.assign({}, position) },
    React.createElement(
      'div',
      { className: styles.tooltip },
      React.createElement(
        'div',
        { className: styles.tooltipText },
        text
      ),
      React.createElement('div', { className: aboveItem ? styles.tooltipTriangleDown : styles.tooltipTriangleUp })
    )
  );
}

export default componentWillAppendToBody(Tooltip);

Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  position: PropTypes.object.isRequired, // eslint-disable-line
  text: PropTypes.string,
  aboveItem: PropTypes.bool
} : {};

Tooltip.defaultProps = {
  text: '',
  aboveItem: true
};